module.exports = __webpack_public_path__ + "media/categories/subjects-0c8dbce5.svg";